// Error message locale key mapping for profile validation
export const etext = {
  NAME_REQUIRED: 'profile.validation.nameRequired',
  EMAIL_REQUIRED: 'profile.validation.emailRequired',
  EMAIL_INVALID: 'profile.validation.emailInvalid',
  PHONE_REQUIRED: 'profile.validation.phoneRequired',
  PHONE_INVALID: 'profile.validation.phoneInvalid',
  BUSINESS_NAME_REQUIRED: 'profile.validation.businessNameRequired',
  BUSINESS_GSTINPAN_REQUIRED: 'profile.validation.businessGstinPanRequired',
  BUSINESS_GSTINPAN_INVALID: 'profile.validation.businessGstinPanInvalid',
  BUSINESS_ADDRESS_REQUIRED: 'profile.validation.businessAddressRequired',
  KYC_STATUS_REQUIRED: 'profile.validation.kycStatusRequired',
};

// Field label locale key mapping (used for user-facing messages)
export const FIELD_LABELS = {
  userName: 'profile.fieldLabels.userName',
  userEmail: 'profile.fieldLabels.userEmail',
  userPhoneNumber: 'profile.fieldLabels.userPhoneNumber',
  userType: 'profile.fieldLabels.userType',
  userBusinessName: 'profile.fieldLabels.userBusinessName',
  userBusinessGstinPan: 'profile.fieldLabels.userBusinessGstinPan',
  userBusinessAddress: 'profile.fieldLabels.userBusinessAddress',
  userKycStatus: 'profile.fieldLabels.userKycStatus',
};
